module.exports = __webpack_public_path__ + "img/pdf.6ae98b1f.png";